export function hasVirtualTourUrl(url?: string | null): boolean {
  return Boolean(url?.trim());
}
